<template>
  <div class="login">
    <div class="form">
      <img src="../assets/logo.png" alt="">
      <div class="form_div">
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="帐号登录" name="first">
            <el-form :model="form" status-icon ref="form" label-width="0px" class="demo-form">
              <el-form-item :rules="[{ required: true, message: '请输入账号'}]" prop="account">
              <el-autocomplete class="inline-input" v-model="form.account" :fetch-suggestions="querySearch"
                placeholder="账号" @keydown.native.enter="login()" style="width:100%"></el-autocomplete>
              </el-form-item>
              <el-form-item :rules="[{ required: true, message: '请输入密码'}]" prop="password">
              <el-input type="password" v-model="form.password" autocomplete="new-password" placeholder="密码"
                @keydown.native.enter="login('form')"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="btn" @click="login()">登录</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="手机登录" name="second">
            <el-form :model="form2" status-icon ref="form2" :rules="rules" label-width="0px" class="demo-form">
              <el-form-item :rules="rules.mobilePhone" prop="mobilePhone">
                <el-autocomplete class="inline-input" v-model="form2.mobilePhone" :fetch-suggestions="querySearchMobile"
                placeholder="手机号" @keydown.native.enter="phoneLogin()" style="width:100%"></el-autocomplete>
              </el-form-item>
              <el-form-item :rules="rules.smsCode" prop="smsCode">
                    <el-input v-model="form2.smsCode" placeholder="验证码"
                    @keydown.native.enter="phoneLogin()">
                    <el-button :disabled="disabled" size="small" slot="append" @click="sendCode('form')"
                      >{{btnText}}
                    </el-button>
                  </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="btn" @click="phoneLogin()">登录</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>

      </div>
    </div>
    <!-- 操作员选择设备 -->
    <!-- <el-dialog title="设备" :visible.sync="dialog" :show-close="false" :center="true" width="400px">
      <el-form status-icon ref="platDeviceId" class="demo-loginForm">
        <el-form-item label="设备">
          <loadSelect ref="loadSelect"
            :obj="{modelVal:placeDeviceId,disabled:false,optionVal:'place_device_id',optionName:'device_name',placeholder:'请选择' }"
            :url="'deviceManage/getDeviceListByPlaceId'" :formData="formDeviceData" :parameter="{ bdUserId: this.userInfo.bdUserId}"
            @changeFn="changePlaceDeviceId"></loadSelect>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="btn" @click="selectPlatDeviceId( )">确定</el-button>
        </el-form-item>
        <div style="color:#9fa2a7;text-align: center;"><a class="cursor_pointer" @click="dialog = false ">取消选择</a>
        </div>
      </el-form>
    </el-dialog> -->
  </div>
</template>

<script>
  import Util from "../Util.js";
  import loadSelect from "../components/loadSelect"
  export default {
    name: 'index',
    components: {
      loadSelect,
    },
    props:{
      ruleForm: {
          type: Object,
          require: true
      },
      countDown: {
          type: Number,
          default: 60
      }
    },
    data() {
      const checkPhone = (rule, value, callback) => {
      if (!value) {
          callback(new Error('手机号不能为空'))
        }
        // 使用正则表达式进行验证手机号码
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('手机号格式不正确'))
        }
        // 自定义校验规则 需要调用callback()函数！
        callback()
      }
      return {
        form: {
          account: "",
          password: ""
        },
        form2: {
          mobilePhone: "",
          smscode: "",
        },
        dialog: false,
        platDeviceId: "",
        platDeviceList: [],
        formDeviceData: { //场地分页
          page: 1,
          size: 10
        },
        activeName: 'first',
        rules: {
              mobilePhone: [
                  {validator: checkPhone, trigger: 'change'}
              ],
              smsCode: [
                  {required: true, message: '验证码不能为空', trigger: 'blur'}
              ]
        },
        disabled: false,
        btnText: '发送验证码'
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
    },
    watch: {
      "dialog"(val, oldVal) {
        if (!val) {
          this.platDeviceId = ""
        }
      }
    },
    mounted() {
      this.time = this.countDown;
      if (Util.getCookie("token")) {
        if(this.userInfo.userType==2) {
          this.$router.push({
            name: "simple"
          });
        } else {
          this.$router.push({
            name: "workbench"
          });
        }
      } else {
        if (this.$route.name == "Login") return;
        this.$router.push({
          name: "Login"
        });
      }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      changePlatDeviceId(val) {
        this.platDeviceId = val
      },
      querySearch(queryString, cb) {
        var restaurants = JSON.parse(localStorage.getItem("accountList")) || [];
        for (let i in restaurants) {
          restaurants[i] = {
            value: restaurants[i]
          }
        }
        var results = queryString ?
          restaurants.filter(this.createFilter(queryString)) :
          restaurants;
        cb(results);
      },
      querySearchMobile(queryString, cb) {
        var restaurants = JSON.parse(localStorage.getItem("mobileList")) || [];
        for (let i in restaurants) {
          restaurants[i] = {
            value: restaurants[i]
          }
        }
        var results = queryString ?
          restaurants.filter(this.createFilter(queryString)) :
          restaurants;
        cb(results);
      },
      createFilter(queryString) {
        return restaurant => {
          return (
            restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0
          );
        };
      },
      selectPlatDeviceId() {
        if (!this.platDeviceId) {
          Util.message("err", "请选择设备")
          return
        }
        this.$store.commit("setParam", {
          platDeviceId: this.platDeviceId
        })
        this.login()
      },
      login() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.platDeviceId) {
              this.form.platDeviceId = this.platDeviceId
            }
            this.$http.post(`${Util.operateURL}deviceManage/login`, this.form).then(
              res => {
                console.log(res);
                if (res.data.code === 200) {
                  let userInfo = res.data.data
                  this.$store.commit("setParam", {
                    userInfo: userInfo
                  })
                  this.goPage()
                } else {
                  Util.message("err", res.data.desc)
                }
              },
              err => {
                console.log(err);
              }
            );
          } else {
            return false;
          }
        });
      },
      phoneLogin(){
        this.$refs["form2"].validate((valid) => {
          console.log(valid);
              if(valid){
                var formMobile = {}
                formMobile.account = this.form2.mobilePhone;
                formMobile.password = this.form2.smsCode;
                this.$http.post(`${Util.operateURL}deviceManage/login`, formMobile).then(
                  res => {
                    console.log(res);
                    if (res.data.code === 200) {
                      let userInfo = res.data.data
                      this.$store.commit("setParam", {
                        userInfo: userInfo
                      })
                      this.goPage2()
                    } else {
                      Util.message("err", res.data.desc)
                    }
                  },
                  err => {
                    console.log(err);
                  }
                );
                this.$message.success('提交成功');
              }else{
                  this.$message.error("填写有误，请检查");
              }
          })
      },
      sendCode(){
          this.$refs["form2"].validateField('mobilePhone', async (valid) => {
            console.log(valid);
            if(!valid) {
              // 1.时间开始倒数
                  // 2.按钮进入禁用状态
                  // 3.如果倒计时结束 按钮恢复可用状态 按钮文字变为重新发送, 时间重置
                  // 4.倒计时的过程中 按钮文字为 多少s后重新发送
                  this.$http.post(`${Util.operateURL}tools/sendCode`, this.form2).then(
                    res => {
                      console.log(res);
                      if (res.data.code === 200) {
                        this.$message.info('发送验证码成功')
                        let timer = setInterval(()=>{
                            this.time --;
                            this.btnText = `${this.time}s后重新发送`
                            this.disabled = true
                            if(this.time === 0){
                                this.disabled = false;
                                this.btnText = '重新发送';
                                this.time = this.countDown
                                clearInterval(timer)
                            }
                        }, 1000)
                      } else {
                        Util.message("err", res.data.desc)
                      }
                    },
                    err => {
                      console.log(err);
                    }
                  );
            } else {
              this.$message.error(valid)
            }
          });
      },
      goPage() {
        Util.setCookie("token", this.userInfo.token, 24 * 365);
        let accountList = JSON.parse(localStorage.getItem("accountList")) || []
        if (accountList.indexOf(this.form.account) == -1) {
          accountList = [...accountList, this.form.account]
        }
        localStorage.setItem("accountList", JSON.stringify(accountList))
        Util.message("suc", "登录成功！")
        this.$router.push({
          name: "workbench"
        });
      },
      goPage2() {
        Util.setCookie("token", this.userInfo.token, 24 * 365);
        let mobileList = JSON.parse(localStorage.getItem("mobileList")) || []
        if (mobileList.indexOf(this.form2.mobilePhone) == -1) {
          mobileList = [...mobileList, this.form2.mobilePhone]
        }
        localStorage.setItem("mobileList", JSON.stringify(mobileList))
        Util.message("suc", "登录成功！");
        this.$router.push({
          name: "simple"
        });
      }
    }
  }

</script>

<style lang="less" scoped>
  .login {
    overflow-x: auto;
    position: absolute;
    left: 0;
    top: 0;
    text-align: center;
    width: 100vw;
    height: 100vh;
  }

  .form {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding-top: 30px;
    width: 360px;
    height: 400px;
    margin: 0 auto;
    background: #dcd8d8;
    border-radius: 5px;
  }

  .form_div {
    margin-top: 40px;

    .el-form-item {
      margin-right: 10px !important;
    }
  }

  .btn {
    width: 100%;
    margin-top: 20px;
  }

  h2 {
    color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue